import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import { OptionActionEnum } from "src/app/shared/data/actions-data";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { UpdateComponent } from "src/app/shared/components/drop-zone-options/modal/update/update.component";
import { TypeCards } from "src/app/shared/enum/typeCards";
import { Observable, takeUntil } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppStateInterface } from "src/app/store/appState.interface";
import { BaseComponent } from "src/app/base.component";
import { invokeCheckIfExistByCompanyName, invokeCheckIfExistByEmail, setCheckUserExistsByCompanyName, setCheckUserExistsByEmail } from "src/app/store/user/user.actions";
import { setFileName } from "src/app/store/file/file.actions";
import { uploadFileSelector } from "src/app/store/file/file.selectors";
import { checkUserExistByCompanyNameSelector, checkUserExistByEmailSelector } from "src/app/store/user/user.selectors";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { PartnerStatus } from "src/app/shared/enum/partner-status";
import { emailValidator } from "src/app/shared/validators/email.validator";
import { requiredWhenValidator } from "src/app/shared/validators/required-when.validator";
import { isRadiusSupportedBrand } from "src/app/shared/enum/routerBrand";
@Component({
  selector: "app-update-location-partner",
  templateUrl: "./update-location-partner.component.html",
})
export class UpdateLocationPartnerComponent
  extends BaseComponent
  implements OnInit
{
  @Input() email: string;
  @Input() locationPartner: LocationPartnerInterface;
  @Input() selectedOption: OptionActionEnum;
  @Input() isFranchise: boolean | null = false;
  @Input() isFranchised: boolean | null = false;

  step = OptionActionEnum;
  companyInformation: FormGroup;
  personalInformation: FormGroup;
  companySpecification: FormGroup;
  locationInformation: FormGroup;
  partnerStatus: FormGroup;
  routerInformation : FormGroup

  filename: string | null;
  uploadFile$: Observable<string | null>;
  checkLocationExistByCompanyName$ : Observable<boolean | null>
  checkLocationExistByEmail$ : Observable<boolean | null>
  checkLocationExistByCompanyName : boolean
  checkLocationExistByEmail : boolean
  constructor(
    private modalService: NgbModal,
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    private translate: TranslateService,
    private toastr: ToastrService,
  ) {
    super(store);
    this.uploadFile$ = this.store
      .pipe(select(uploadFileSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.checkLocationExistByCompanyName$ = this.store
      .pipe(select(checkUserExistByCompanyNameSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.checkLocationExistByEmail$ = this.store
      .pipe(select(checkUserExistByEmailSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    (this.personalInformation = this.fb.group({
      email: new FormControl(null, [Validators.required, emailValidator()]),
      firstName: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
      ]),
      lastName: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
      ]),
      phone: [
        null,
        [Validators.required, Validators.pattern("^(?=.*?[0-9]).{8}$")],
      ],
      companyRole: new FormControl(null, [Validators.required])
    })),
      (this.companyInformation = this.fb.group({
        companyName: new FormControl(null, [Validators.required]),
        companyAddress: new FormControl(null, [Validators.required]),
        companyActivity: new FormControl(null, [Validators.required]),
        logo: new FormControl(null),
        category: new FormControl(null, [Validators.required]),
        subCategories: new FormControl(null, [Validators.required]),
        tags: new FormControl(null, [Validators.required]),
      })),
      (this.locationInformation = this.fb.group({
        //address: new FormControl(null, [Validators.required]),
        latitude: new FormControl(null, [Validators.required]),
        longitude: new FormControl(null, [Validators.required]),
        zone: new FormControl(null, [Validators.required])
      }));
    this.partnerStatus = this.fb.group({
      expenses: new FormControl(null),
      partnerStatus: new FormControl(null, [Validators.required]),
      date: new FormControl([null, null]),
      paymentFrequency: new FormControl(null),
      price: new FormControl(null),
      showingAdmin: new FormControl(null),
      showingAdvertiser: new FormControl(null),
      status : new FormControl(null, [Validators.required]),
    });
    this.routerInformation = this.fb.group(
      {
        sessionTimeoutInMinutes : new FormControl(null, [Validators.required]),
        routerBrand : new FormControl(null, [Validators.required]),
        radiusEnabled: new FormControl(false),
        radUsername: new FormControl(null),
        radPassword: new FormControl(null),
      },
      {
        validators: requiredWhenValidator("radiusEnabled", ["radUsername", "radPassword"]),
      }
    )
  }

  ngOnInit(): void {
    this.checkLocationExistByCompanyName$.subscribe((data)=>{
      if(data != null){
        this.checkLocationExistByCompanyName = data
        this.store.dispatch(setCheckUserExistsByCompanyName({isExistByCompanyName : null}))
        if(!data && !this.checkLocationExistByEmail){
          this.updateComponent();
        }
      }
    })
    this.checkLocationExistByEmail$.subscribe((data)=>{
      if(data != null){
        this.checkLocationExistByEmail = data
        this.store.dispatch(setCheckUserExistsByEmail({isExist : null}))
        if(data){
          this.toastr.error(
            this.translate.instant("response.error.email-exist"),
            this.translate.instant("response.errorTitle")
          );
        }
        if(!data && !this.checkLocationExistByCompanyName){
          this.updateComponent();
        }
      }
    })
    this.uploadFile$.subscribe((result: string | null) => {
      if (result != null) {
        this.filename = result;
        this.store.dispatch(setFileName({ filename: null }));
      }
    });

    this.personalInformation.patchValue({
      email: this.locationPartner.email.toLowerCase(),
      firstName: this.locationPartner.firstName,
      lastName: this.locationPartner.lastName,
      phone: this.locationPartner.phone,
      companyRole: this.locationPartner.companyRole
    });
    this.companyInformation.patchValue({
      companyName: this.locationPartner.companyName,
      companyAddress: this.locationPartner.companyAddress,
      companyActivity: this.locationPartner.companyActivity,
      logo: this.locationPartner.logo,
      category: this.locationPartner.category,
      subCategories: this.locationPartner.subCategories,
      tags: this.locationPartner.tags
    });
    this.locationInformation.patchValue({
      latitude: this.locationPartner.latitude,
      longitude: this.locationPartner.longitude,
      zone: this.locationPartner.zoneName,
    });
    this.partnerStatus.patchValue({
      expenses: this.locationPartner.expenses,
      partnerStatus: this.locationPartner.partnerStatus,
      paymentFrequency: this.locationPartner.paymentFrequency,
      date: [
        this.locationPartner.pilotPhaseStartDate,
        this.locationPartner.pilotPhaseEndDate,
      ],
      price: this.locationPartner.price,
      showingAdmin: this.locationPartner.showingAdmin,
      showingAdvertiser: this.locationPartner.showingAdvertiser,
      status : this.locationPartner.status,
    });
    this.routerInformation.patchValue({
      sessionTimeoutInMinutes : this.locationPartner.sessionTimeoutInMinutes,
      routerBrand : this.locationPartner.routerBrand,
      radiusEnabled:
        isRadiusSupportedBrand(this.locationPartner.routerBrand) &&
        (this.locationPartner.radiusEnabled ?? false),
      radUsername: this.locationPartner.radUsername,
      radPassword: this.locationPartner.radPassword
    })
  }
  onClickCloseModal() {
    this.modalService.dismissAll();
  }
  updateComponent() {
    // RADIUS credentials are only kept when the brand supports RADIUS and it is enabled; otherwise they are cleared.
    const radiusEnabled =
      isRadiusSupportedBrand(this.routerInformation.get("routerBrand")?.value) &&
      this.routerInformation.get("radiusEnabled")?.value === true;
    this.locationPartner = {
      email: this.personalInformation.get("email")?.value.toLowerCase() ?? this.locationPartner.email,
      firstName: this.personalInformation.get("firstName")?.value ?? this.locationPartner.firstName,
      lastName: this.personalInformation.get("lastName")?.value ?? this.locationPartner.lastName,
      password: this.personalInformation.get("password")?.value ?? this.locationPartner.password,
      companyName: this.companyInformation.get("companyName")?.value ?? this.locationPartner.companyName,
      companyAddress: this.companyInformation.get("companyAddress")?.value ?? this.locationPartner.companyAddress,
      companyActivity: this.companyInformation.get("companyActivity")?.value ?? this.locationPartner.companyActivity,
      companyRole: this.personalInformation.get("companyRole")?.value ?? this.locationPartner.companyRole,
      phone: this.personalInformation.get("phone")?.value ?? this.locationPartner.phone,
      category: this.companyInformation.get("category")?.value ?? this.locationPartner.category,
      subCategories: this.companyInformation.get("subCategories")?.value ?? this.locationPartner.subCategories,
      tags: this.companyInformation.get("tags")?.value ?? this.locationPartner.tags,
      longitude: this.locationInformation.get("longitude")?.value ?? this.locationPartner.longitude,
      latitude: this.locationInformation.get("latitude")?.value ?? this.locationPartner.latitude,
      zoneName: this.locationInformation.get("zone")?.value ?? this.locationPartner.zoneName,
      partnerStatus: this.partnerStatus.get("partnerStatus")?.value ?? this.locationPartner.partnerStatus,
      paymentFrequency: this.partnerStatus.get("paymentFrequency")?.value ?? this.locationPartner.paymentFrequency,
      pricingMethod: this.locationPartner.pricingMethod,
      price: this.partnerStatus.get("price")?.value ?? this.locationPartner.price,
      pilotPhaseStartDate: this.partnerStatus.get("date")?.value[0] ?? null,
      pilotPhaseEndDate: this.partnerStatus.get("date")?.value[1] ?? null,
      expenses: this.partnerStatus.get("expenses")?.value ?? this.locationPartner.expenses,
      showingAdmin: this.partnerStatus.get("showingAdmin")?.value ?? this.locationPartner.showingAdmin,
      showingAdvertiser: this.partnerStatus.get("showingAdvertiser")?.value ?? this.locationPartner.showingAdvertiser,
      logo: this.filename ?? this.partnerStatus.get("companyInformation.logo")?.value ?? this.locationPartner.logo,
      endDateAverage: this.locationPartner.endDateAverage,
      startDateAverage: this.locationPartner.startDateAverage,
      premiumEndDate: this.locationPartner.premiumEndDate,
      region: this.locationPartner.region,
      status : this.partnerStatus.get("status")?.value ?? this.locationPartner.status,
      hashedId : this.locationPartner.hashedId,
      routerBrand : this.routerInformation.get("routerBrand")?.value ?? this.locationPartner.routerBrand,
      sessionTimeoutInMinutes : this.routerInformation.get("sessionTimeoutInMinutes")?.value ?? this.locationPartner.sessionTimeoutInMinutes,
      radiusEnabled,
      radUsername: radiusEnabled ? this.routerInformation.get("radUsername")?.value : null,
      radPassword: radiusEnabled ? this.routerInformation.get("radPassword")?.value : null,
      billingAddress : this.locationPartner.billingAddress,
      legalName : this.locationPartner.legalName,
      taxRegistration : this.locationPartner.taxRegistration,
      archivedDate : this.locationPartner.archivedDate
    }; 
    this.onClickCloseModal();
    const modalRef = this.modalService.open(UpdateComponent, {
      centered: true,
      size: this.isFranchised ? "lg" : (!this.isFranchise ? "xl"  : undefined),
    });
    modalRef.componentInstance.type = this.isFranchise ? TypeCards.ADMIN_FRANCHISE_UPDATE : TypeCards.ADMIN_LOCATION_UPDATE;
    modalRef.componentInstance.isCol4 = this.isFranchised;
    modalRef.componentInstance.title = "LPOptions.update";
    modalRef.componentInstance.email = this.email.toLowerCase();
    modalRef.componentInstance.locationPartner = this.locationPartner;
    modalRef.componentInstance.isFranchise = this.isFranchise;
    modalRef.componentInstance.isFranchised = this.isFranchised;
    modalRef.componentInstance.isMissingStatusData = 
      this.locationPartner.partnerStatus === null ||
        (this.locationPartner.partnerStatus === PartnerStatus.REVENUE_SHARING && this.locationPartner.pilotPhaseEndDate === null) ||
        (this.locationPartner.partnerStatus === PartnerStatus.INTERNET_PROVIDER_PAYMENT && this.locationPartner.paymentFrequency === null)
    modalRef.componentInstance.isMissingRouterData =
      !this.locationPartner.sessionTimeoutInMinutes || !this.locationPartner.routerBrand;
  }
  onClickBack() {
    this.updateComponent();
  }
  saveChanges() {
    let isUpdateCompanyName = false
    let isUpdateEmail = false
    if(this.selectedOption == this.step.ADMIN_UPDATE_LOCATION_PERSONNELLE_INFORMATION && 
      this.locationPartner.companyName != this.companyInformation.get("companyName")?.value){
        isUpdateCompanyName = true
      this.store.dispatch(
        invokeCheckIfExistByCompanyName({ companyName: this.companyInformation.get("companyName")?.value })
      );
    }
    if (this.selectedOption ==this.step.ADMIN_UPDATE_LOCATION_PERSONNELLE_INFORMATION &&
      this.locationPartner.email.toLowerCase() != this.personalInformation.get("email")?.value.toLowerCase()
  ) {
      isUpdateEmail = true;
      this.store.dispatch(
        invokeCheckIfExistByEmail({
          email: this.personalInformation.get("email")?.value.toLowerCase(),
        })
      );
    }
    if(!isUpdateCompanyName && !isUpdateEmail){
      this.updateComponent();
    }
  }
  checkUserExist() {
    this.store.dispatch(
      invokeCheckIfExistByEmail({
        email: this.personalInformation.get("email")?.value.toLowerCase(),
      })
    );
  }

  isDisableButton() {
    switch (this.selectedOption) {
      case OptionActionEnum.ADMIN_UPDATE_LOCATION_PERSONNELLE_INFORMATION: {
        return !this.personalInformation.valid;
      }
      case OptionActionEnum.ADMIN_UPDATE_LOCATION_COMPANY_SPECIFICATION: {
        return !this.companyInformation.valid ||
            !this.companyInformation.get('logo')?.value;
      }
      case OptionActionEnum.ADMIN_UPDATE_LOCATION_LOCATION_INFORMATION: {
        return !this.locationInformation.valid;
      }
      case OptionActionEnum.ADMIN_UPDATE_LOCATION_PARTNER_STATUS_INFORMATION: {
        return !this.partnerStatus.valid;
      }
      case OptionActionEnum.ADMIN_UPDATE_LOCATION_PARTNER_ROUTER_INFORMATION: {
        return !this.routerInformation.valid
      }
      default:
        return;
    }
  }

  getFileName() {
    return this.filename ?? this.partnerStatus.get("companyInformation.logo")?.value ?? this.locationPartner.logo;
  }
}
